import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.bg};
  padding: ${({ theme }) => theme.spacing[6]};
  transition: background-color ${({ theme }) => theme.transition.slow};

  .error-card {
    text-align: center;
    max-width: 440px;
    width: 100%;
    background-color: ${({ theme }) => theme.colors.surface};
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: ${({ theme }) => theme.borderRadius.md};
    padding: ${({ theme }) => theme.spacing[8]}
      ${({ theme }) => theme.spacing[6]};
    transition:
      background-color ${({ theme }) => theme.transition.slow},
      border-color ${({ theme }) => theme.transition.slow};
  }

  .error-icon {
    color: ${({ theme }) => theme.colors.error.base};
    margin-bottom: ${({ theme }) => theme.spacing[4]};
  }

  h1 {
    font-size: ${({ theme }) => theme.fontSize.xl};
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    color: ${({ theme }) => theme.colors.text.primary};
    margin-bottom: ${({ theme }) => theme.spacing[2]};
  }

  p {
    font-size: ${({ theme }) => theme.fontSize.base};
    color: ${({ theme }) => theme.colors.text.muted};
    margin-bottom: ${({ theme }) => theme.spacing[6]};
    line-height: 1.5;
  }

  .error-actions {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${({ theme }) => theme.spacing[3]};
    flex-wrap: wrap;
  }
`;
